import {numberFormat} from "@pg-mono/string-utils";

export const formatMetaPriceSegment = (lowestPrice: number | null | undefined, prefix: string, suffix: string): string => {
    if (!lowestPrice || lowestPrice <= 0) {
        return "";
    }

    return `${prefix}${numberFormat(lowestPrice)} zł${suffix}`;
};
